export const goToLabel = (label: string) => {
  return `Go to → ${label}`;
};

export const tokenizedMatches = (query: string, target: string): boolean => {
  const tokens = query.split(" ");
  if (tokens.length === 0) {
    return true;
  }

  let start = 0;
  for (const token of tokens) {
    if (!token.length) {
      continue;
    }

    const found = target.indexOf(token, start);
    if (found === -1) {
      return false;
    }
    start = found + token.length;
  }

  return true;
};
